import { CameraAltRounded } from "@mui/icons-material";
import Box from "@mui/material/Box";
import type React from "react";
import { forwardRef } from "react";

interface ProfilePictureProps
	extends React.InputHTMLAttributes<HTMLInputElement> {
	image?: string;
}

const InputProfilePicture = forwardRef<HTMLInputElement, ProfilePictureProps>(
	({ image = "/images/blank-avatar.svg", ...props }, ref) => {
		return (
			<Box
				component="label"
				htmlFor={props.name}
				className="relative w-24 h-24 cursor-pointer"
			>
				<Box className="h-full w-full rounded-full overflow-hidden bg-gray-300">
					<img
						className="h-full w-full object-cover"
						src={image}
						alt="avatar"
					/>
				</Box>
				<Box className="absolute bottom-0 right-0 w-8 h-8 bg-white rounded-full flex items-center justify-center p-2">
					<input
						ref={ref}
						id={props.name}
						type="file"
						accept="image/*"
						className="hidden"
						aria-label="Profile Picture"
						{...props}
					/>
					<CameraAltRounded className="text-gray-600" />
				</Box>
			</Box>
		);
	},
);

export default InputProfilePicture;
